import { render, staticRenderFns } from "./sortModalPart.vue?vue&type=template&id=777288a4&"
import script from "./sortModalPart.vue?vue&type=script&lang=js&"
export * from "./sortModalPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports